import { proxy } from 'valtio'

const COLORS = [
  '#8B00FF',
  '#0A0A0A',
  '#FFD700',
  '#ffffff',
  '#00C853',
  '#FF6F00',
  '#006E6D',
  '#85C1E9',
]

const AUTO_ROTATE_DELAY = 10000
const COLOR_CHANGE_INTERVAL = 5000

const state = proxy({
  colors: COLORS,
  selectedColor: '#8B00FF',
  autoRotate: true,
})

export { state, AUTO_ROTATE_DELAY, COLOR_CHANGE_INTERVAL }
